import { Pipe, PipeTransform, OnDestroy } from '@angular/core';
import { formatDate } from '@angular/common';
import { AppLocaleService } from '@app/core/services/app-locale.service';
import { Subscription } from 'rxjs';

@Pipe({
    name: 'cassTimestamp',
    pure: false
})
export class CassTimestampPipe implements PipeTransform, OnDestroy {

    lastInput: string | Date | number | null | undefined;
    lastOutput: string | undefined;
    currentLocaleId$?: Subscription;

    constructor(private _appLocaleService: AppLocaleService) {
        this.currentLocaleId$ = this._appLocaleService.currentLocale$.subscribe(_ => {
            this.lastInput = undefined;
            this.lastOutput = undefined;
        });
    }

    ngOnDestroy(): void {
        this.currentLocaleId$?.unsubscribe();
    }

    transform(value: string | Date | number | null | undefined): string | undefined {
        if (value === this.lastInput) {
            return this.lastOutput;
        }
        if (!value) return;
        this.lastInput = value;
        this.lastOutput = formatDate(value, this._appLocaleService.timestampFormat, this._appLocaleService.currentOrDefaultLocaleId);
        return this.lastOutput;
    }
}
